import { Attribute, Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
	selector: '[appTimeAllowed][formControlName],[appTimeAllowed][formControl],[appTimeAllowed][ngModel]',
	providers: [
		{provide: NG_VALIDATORS, useExisting: forwardRef(() => TimeAllowedValidator), multi: true}
	]
})
export class TimeAllowedValidator implements Validator {
	constructor(@Attribute('timeAllowed') public timeAllowed: any,
				@Attribute('deliveryTime') public deliveryTime: any,
				@Attribute('deliveryDate') public deliveryDate: any) {

	}

	public get isdeliveryTime() {
		if (!this.deliveryTime) { return false; }
		return this.deliveryTime === 'true';
	}

	validate(c: AbstractControl): { [key: string]: any } {
		// self value
		const v = c.value;

		// control value
		const e = c.root.get(this.timeAllowed);
		// control value
		const d = c.root.get(this.deliveryDate);

		if (e && e.value && e.value.jsdate && !this.isdeliveryTime) {
			// Create date from input value
			const inputDate = new Date(e.value.jsdate);

			// Get today's date
			const todaysDate = new Date();

			// call setHours to take the time out of the comparison
			if (inputDate.setHours(0, 0, 0, 0) === todaysDate.setHours(0, 0, 0, 0)) { // Date equals today's date
				const currentTime = new Date().getTime() - 300000; // CurrentTime minus 5 min leeway
				if (currentTime > new Date(v).getTime()) {
					return {
						timeAllowed: false
					};
				} else {
					return null;
				}
			}
		} else if (d && d.value && d.value.jsdate && this.isdeliveryTime) {
			const pickupTime = (<HTMLInputElement>document.getElementById('readyTimeFrom')).value;

			// Create date from input value
			const pickupDate = new Date(e.value.jsdate);
			const deliveryDate = new Date(d.value.jsdate);

			// If pickupDate and deliveryDate are the same then delivery time must be greater
			// than pickup time
			if (pickupDate.setHours(0, 0, 0, 0) === deliveryDate.setHours(0, 0, 0, 0) &&
				pickupTime > v.toString()) {
				return {
					timeAllowed: false
				};
			} else {
				return null;
			}
		}

		return null;
	}
}
